import { yupResolver } from "@hookform/resolvers/yup";
import {
  CategoriesGroupAPI,
  CategoryFieldSetsAPI,
  CategoryVariantsAPI,
} from "api";
import BreadCrumb from "components/breadcrumb/BreadCrumb";
import React, { useEffect } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { customSettings } from "utils/customConfig";
import * as yup from "yup";
import CategoryGroupBasicInformation from "./CategoryGroupBasicInformation";
import { Helmet } from "react-helmet";
import PageTitle from "utils/PageTitle";
import BreadCrumbTable from "../../../../breadcrumb/BreadCrumbTable";

const schema = yup
  .object({
    name: yup.string().required("Name is required"),
    sortOrder: yup.string().required("Display order is required"),
    description: yup.string(),
    // logo: yup.string().required("Logo is required"),
    logo: yup.string().nullable(),
    bannerImage: yup.string().nullable(),
    categories: yup.array().of(
      yup.object().shape({
        categoryId: yup.string().required("Category is required"),
        sortOrder: yup.number(),
        // status: yup.boolean(),
      }),
    ),
    status: yup.boolean(),
    showBanner: yup.boolean(),
    isNew: yup.boolean(),
    isHot: yup.boolean(),
    metaKeyword: yup.string().nullable(),
    metaDescription: yup.string().nullable(),
  })
  .required();

const AddCategoryGroup = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const submittedValues = {};
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      categories: [{ sortOrder: 0 }],
    },
  });
  const { handleSubmit, reset, setValue } = methods;

  const onSubmit = async (data) => {
    // console.log("data before", data);
    let myData = {
      ...data,
      id: location?.state?.id ?? 0, // Use nullish coalescing to handle undefined or null
      logo: data.logo ?? "",
      bannerImage: data.bannerImage ?? "",
      categories: data.categories?.map((d) => {
        return {
          sortOrder: d.sortOrder,
          categoryId: d.categoryId,
          category: "",
        };
      }),
    };

    // console.log(myData);

    try {
      if (location?.state) {
        await CategoriesGroupAPI.post(myData);
        toast.success("Category group updated successfully", {
          position: customSettings.toastPosition,
          autoClose: customSettings.toastClose,
        });
      } else {
        await CategoriesGroupAPI.post(myData);
        toast.success("Category group created successfully", {
          position: customSettings.toastPosition,
          autoClose: customSettings.toastClose,
        });
      }

      // ------- Get all object keys form data and set empty values to reset ------------
      const keys = Object.keys(data);
      for (const key of keys) {
        submittedValues[key] = "";
      }
      reset({ ...submittedValues });
      navigate(-1);
    } catch (error) {
      toast.error("Something went wrong", {
        position: customSettings.toastPosition,
        autoClose: customSettings.toastClose,
      });
      console.log(error);
    }
  };

  useEffect(() => {
    if (location.state) {
      // if (location.state?.categories?.length < 0) {
      //   console.log(location.state?.categories?.length < 0);
      //   setValue("categories", [{}]);
      // }
      // console.log(location.state);
      reset(location.state);
    }
  }, [setValue]);

  return (
    <>
      <PageTitle name="Libraries | Category Group" />

      {/* <div className="py-2">
        <BreadCrumb />
      </div> */}
      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit(onSubmit)} noValidate>
          <Card>
            <Card.Header className="border-bottom">
              <Row className="flex-between-center ">
                <Col md>
                  <BreadCrumbTable
                    title="Libraries"
                    subTitle="Category Group"
                    subSubTitle={location?.state?.name}
                  />
                  {/* <h5 className="fs-9 text-nowrap mb-2 mb-md-0">
                    Libraries | Category Group
                  </h5> */}
                </Col>
                <Col xs="auto" style={{ paddingRight: "12px" }}>
                  <Button
                    variant="link"
                    className="text-secondary fw-medium p-0 me-3"
                    type="button"
                    onClick={() => navigate(-1)}
                  >
                    Cancel
                  </Button>
                  <Button variant="primary" type="submit">
                    Ok
                  </Button>
                </Col>
              </Row>
            </Card.Header>
            <CategoryGroupBasicInformation />
            {/* <Row className="">
            
              <Col lg={12}>
              </Col> */}
            {/* <Col xs={12}>
    
            </Col> */}
            {/* </Row> */}
          </Card>
        </Form>
      </FormProvider>
    </>
  );
};

export default AddCategoryGroup;
